import http from './http';
import {METADATA_BASE} from './paths';
import {withPerm} from './perm';

// 도메인데이터 목록 조회
export const getDomainDataList = withPerm(async () => {
  const response = await http.get(`${METADATA_BASE}/domainData`);
  return response.data;
}, 'GET', `${METADATA_BASE}/domainData`);

// 도메인데이터 생성
export const createDomainData = withPerm(async (domainData) => {
  const response = await http.post(`${METADATA_BASE}/domainData`, domainData);
  return response.data;
}, 'POST', `${METADATA_BASE}/domainData`);

// 도메인데이터 일괄 생성
export const createDomainDataBatch = withPerm(async (domainDataList) => {
  const response = await http.post(`${METADATA_BASE}/domainData/batch`, domainDataList);
  return response.data;
}, 'POST', `${METADATA_BASE}/domainData/batch`);

// 도메인데이터 단건 삭제 (백엔드와 일치)
export const deleteDomainData = withPerm(async (domainDataId) => {
  const response = await http.delete(`${METADATA_BASE}/domainData/${domainDataId}`);
  return response.data;
}, 'DELETE', `${METADATA_BASE}/domainData/{domainDataId}`);

// 도메인데이터 일괄 삭제(헬퍼)
export async function deleteDomainDataBatch(idList = []) {
  if (!Array.isArray(idList) || idList.length === 0) return { deleted: 0 };
  let deleted = 0; const errors = [];
  for (const id of idList) {
    try { await deleteDomainData(id); deleted++; }
    catch (e) { errors.push({ id, status: e?.response?.status, message: e?.message }); }
  }
  return { deleted, errors };
}
